<template lang="html">
  <div id="project-description-section">

    <section class="container oversized-container">
      <div class="row">
        <div class="col-md-12 mt-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">{{ $t("shared.titles.home") }}</router-link></li>
              <li class="breadcrumb-item"><router-link to="/proyectos">{{ $t("shared.titles.projects") }}</router-link></li>
              <li class="breadcrumb-item"><router-link :to="'/proyectos/categoria/'+proyecto.categories_id['id']">{{ $t("shared.titles.list") }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{proyecto.name}}</li>
            </ol>
          </nav>
        </div>
      </div>
    </section>

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-lg-6 col-gallery">
          <!-- Big images -->
          <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide v-for="(i, iInx) in proyecto.gallery" :key="'iInx-'+iInx">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+i+')' }"></div>
            </swiper-slide>

            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </swiper>
          <!--  -->

          <!-- Thumbs -->
          <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
            <swiper-slide class="slide-1" v-for="(i, itInx) in proyecto.gallery" :key="'itInx-'+itInx">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+i+')' }"></div>
            </swiper-slide>
          </swiper>
          <!--  -->
        </div>

        <div class="col-lg-6 col-description">
          <h2 class="title">{{ proyecto.name }}</h2>

          <div class="box-description" v-html="proyecto.description"></div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      gallery: [
        /*{ url: 'public/images/pages/projects/project-1-xl.jpg' },
        { url: 'public/images/pages/projects/project-1-sm.jpg' },
        { url: 'public/images/pages/projects/project-1-sm.jpg' },
        { url: 'public/images/pages/projects/project-1-xl.jpg' },
        { url: 'public/images/pages/projects/project-1-sm.jpg' },*/
      ],

      proyecto:{
        id: 55,
        name: "Torre de Departamentos en Vista Hermosa Cuernavaca",
        description: `<p>
            Proyecto en una colonia de lujo de Vista Hermosa en Cuernavaca con ventanas y puertas de PVC acabado Golden Oak. Puertas corredizas de altura hasta 3.2m con vidrios laminados.
          </p>
          <br />
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
        `,
        categories_id: {
          id: 5,
          label: "Edificios"
        },
        position: 150,
        image_id: 861,
        name_en: "Apartment Tower in Vista Hermosa Cuernavaca",
        description_en: "<p><span style=\"background-color: rgb(245, 245, 245); color: rgb(60, 64, 67);\">Project in a luxury neighborhood of Vista Hermosa in Cuernavaca with PVC windows and doors with Golden Oak finish. Sliding doors up to 12´ high with laminated glass.</span></p>",
        created_at: "2020-04-22 17:39:03",
        updated_at: "2023-06-09 18:15:33",
        imageUrl: "https://eslowindows.com/img/5ea0813779407",
        gallery: [
          /*"https://esloventanas.com/img/5ea6f9afdf798",
          "https://esloventanas.com/img/5ea0823e3acee",
          "https://esloventanas.com/img/5ea081ca48192",
          "https://esloventanas.com/img/5ea081be8477a",
          "https://esloventanas.com/img/5ea081b23ac38",
          "https://esloventanas.com/img/5ea081a9f41bb",
          "https://esloventanas.com/img/5ea081a1e9e83",
          "https://esloventanas.com/img/5ea081978c690",
          "https://esloventanas.com/img/5ea0818d76e4a"*/
        ],
        videos: []
      },

      // == Carousels options ==
      swiperOptionTop: {
        loop: true,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      // == ==
    }
  },

  methods: {
    runCarousel(){
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },

    getProject:function(id){
      axios.get(tools.url('/detalleprojectFront/'+this.id)).then(
        ({data}) =>{
          this.proyecto=data;
          this.runCarousel();
          this.swiperOptionTop.loopedSlides = this.proyecto.gallery.length;
          this.swiperOptionThumbs.loopedSlides = this.proyecto.gallery.length;
        }
      );
    },
  },

  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    });

     this.id = this.$route.params.id;
     this.getProject(this.id);
  }
}
</script>
